import React from "react";
import Layout from "../../components/layout/Layout";
import OtherTreatmentsTable from "../../components/tables/chemical/OtherTreatmentsTable";

const OtherTreatments = () => {
  return (
    <Layout>
      <OtherTreatmentsTable />
    </Layout>
  );
};

export default OtherTreatments;
